import * as c3 from 'c3';
import Chart from 'src/javascripts/components/Chart';
import Spinner from 'src/javascripts/components/utilities/Spinner';
import ImpactDistChartTooltip from 'src/javascripts/components/charts/tooltips/ImpactDistChartTooltip';
import NoDataMessage from 'src/javascripts/components/alerts/NoDataMessage';

export default class ImpactDistControversies extends Chart {

  getData() {

    // Set a spinner to indicate chart loading
    Spinner(this.chartId);

    // Set url
    const url = this.el.attr('data-api-url');

    // Get data
    return $.getJSON(url);

  }

  render(data) {

    // Set chartId
    const chartId = this.chartId;

    // Show no data message if none available
    // data[1] is the chart data; data[0] is dates array
    if ((data === null) || (data[1].length <= 1) || (typeof data[1] === 'undefined')) { 
      return NoDataMessage(this.el); 
    }

    // Render chart
    const chart = c3.generate({
      bindto: '#' + chartId,
      padding: {left: 0, bottom: -30},
      data: {
        type: 'bar',
        json: data,
        labels: true,
        keys: {
          x: 'name',
          value: [ 'value' ]
        },
        onclick: function (d, element) { 

          // Focus/de-focus, depending on current status
          if ( $(element).hasClass('selected') ) {

            $(element).closest('.chart-container').find('.c3-bar').removeClass('lightest selected').addClass('opaque');
            let oTable = $('#' + chartId).closest('.card').find('.controversies-table').DataTable();
            oTable.search('').draw();

          } else {

            $(element).removeClass('lightest').addClass('opaque selected');
            $(element).closest('.chart-container').find('.c3-bar').not(element).removeClass('opaque selected').addClass('lightest');

            // On click of a bar, update table to show ratings for that severity 
            let severitySearch;
            if (d.x === 0) {
              severitySearch = "Low";
            } else if (d.x === 1) {
              severitySearch = "Low to moderate";
            } else if (d.x === 2) {
              severitySearch = "Moderate";
            } else if (d.x === 3) {
              severitySearch = "High";
            } else {
              severitySearch = "Very high";
            }

            // Search for the letter search (filtering handled in controller)
            let oTable = $('#' + chartId).closest('.card').find('.controversies-table').DataTable();
            oTable.search('"' + severitySearch + '"').draw();

          }

        }
      },
      axis: {
        x: {type: 'category'},
        y: {
          show: false,
          padding: {top: 20}
        }
      },
      bar: {width: {ratio: 0.8}},
      legend: {hide: true},
      tooltip: {
        format: {},
        contents(d, defaultTitleFormat, defaultValueFormat, color) {
          return ImpactDistChartTooltip(this, d, defaultTitleFormat, defaultValueFormat, color);
        }
      },

      // Add color to bars
      onrendered() {
        $('#impact_dist_controversies .c3-bar-0').addClass('bg-a-rating opaque');
        $('#impact_dist_controversies .c3-bar-1').addClass('bg-b-rating opaque');
        $('#impact_dist_controversies .c3-bar-2').addClass('bg-c-rating opaque');
        $('#impact_dist_controversies .c3-bar-3').addClass('bg-d-rating opaque');
        $('#impact_dist_controversies .c3-bar-4').addClass('bg-f-rating opaque');

        // Remove opacity and spinner, unless an impact table is also present (that will remove spinner)
        if ( $('.controversies-table').length === 0 ) {
          $('#' + chartId).closest('.card-body').removeClass('opaque');
          $('#' + chartId).closest('.card').find('.spinner-container').remove();
        }

        // On click of a tick
        $('#' + chartId + ' .c3-axis-x g.tick text').off('click').on('click', function() {

          // Set index
          let text = $(this).text();

          let c3bar = $('.c3-bar.bg-' + text.toLowerCase() + '-rating');

          // Focus/de-focus, depending on current status
          if ( c3bar.hasClass('selected') ) {

            c3bar.closest('.chart-container').find('.c3-bar').removeClass('lightest selected').addClass('opaque');
            let oTable = $('#' + chartId).closest('.card').find('.controversies-table').DataTable();
            oTable.search('').draw();

          } else {

            c3bar.removeClass('lightest').addClass('opaque selected');
            c3bar.closest('.chart-container').find('.c3-bar').not(c3bar).removeClass('opaque selected').addClass('lightest');

            // Search for the letter search (filtering handled in controller)
            let oTable = $('#' + chartId).closest('.card').find('.controversies-table').DataTable();
            oTable.search('"' + text + ' rating' + '"').draw();

          }

        });

      }

    });

    // Set chart data to allow for destroying chart before Turbo cache
    // https://stackoverflow.com/questions/25765596/how-to-get-object-reference-from-selector-for-c3-js-charts
    $('#' + chartId).data('c3-chart', chart);

    return chart;

  }
};
